import { render, staticRenderFns } from "./add_expert_service.vue?vue&type=template&id=3f2c5b6a&scoped=true&"
import script from "./add_expert_service.vue?vue&type=script&lang=js&"
export * from "./add_expert_service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2c5b6a",
  null
  
)

export default component.exports